export enum CONNECTION_ERROR_CODES {
    NO_SAP_CONNECTION = 'NO_SAP_CONNECTION',
    NO_INTERNET_CONNECTION = 'NO_INTERNET_CONNECTION',
    OFFLINE_PLUGIN_SYNC_ERROR = 'OFFLINE_PLUGIN_SYNC_ERROR',
    OFFLINE_STORE_SAVE_ERROR = 'OFFLINE_STORE_SAVE_ERROR',
    NO_ERROR = 'NO_ERROR',
    INVALID_DATE_TIME_ERROR = 'INVALID_DATE_TIME_ERROR',
    AUTH_ERROR = 'AUTH_ERROR',
}

export function isConnectionErrorCode(error: unknown): error is CONNECTION_ERROR_CODES {
    return <CONNECTION_ERROR_CODES>error in CONNECTION_ERROR_CODES;
}
